import axios from 'axios';

// API 기본 URL 설정
const API_BASE_URL = process.env.REACT_APP_API_URL 

// Owner API 클래스
class OwnerAPI {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  // 토큰이 포함된 헤더 생성
  getAuthHeaders() {
    const token = localStorage.getItem('ownerToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  // 공통 axios 설정
  getAxiosConfig(additionalHeaders = {}) {
    return {
      headers: {
        ...this.getAuthHeaders(),
        ...additionalHeaders,
      },
    };
  }

  // 클럽 관련 API
  async getClubs() {
    const response = await axios.get(
      `${this.baseURL}/api/owner/clubs`,
      this.getAxiosConfig()
    );
    return response.data;
  }

  async getMyClub() {
    const response = await axios.get(
      `${this.baseURL}/api/owner/club/me`,
      this.getAxiosConfig()
    );
    return response.data;
  }

  async getClubById(clubId) {
    const response = await axios.get(
      `${this.baseURL}/api/owner/club/${clubId}`,
      this.getAxiosConfig()
    );
    return response.data;
  }

  async updateClub(clubId, formData) {
    const response = await axios.put(
      `${this.baseURL}/api/owner/club/${clubId}`,
      formData,
      this.getAxiosConfig({ 'Content-Type': 'multipart/form-data' })
    );
    return response.data;
  }

  async createClub(formData) {
    const response = await axios.post(
      `${this.baseURL}/api/owner/clubs`,
      formData,
      this.getAxiosConfig({ 'Content-Type': 'multipart/form-data' })
    );
    return response.data;
  }

  async deleteClub(clubId) {
    const response = await axios.delete(
      `${this.baseURL}/api/owner/clubs/${clubId}`,
      this.getAxiosConfig()
    );
    return response.data;
  }

  // 이벤트 관련 API
  async getEvents() {
    const response = await axios.get(
      `${this.baseURL}/api/owner/events`,
      this.getAxiosConfig()
    );
    return response.data;
  }

  async deleteEvent(eventId) {
    const response = await axios.delete(
      `${this.baseURL}/api/owner/events/${eventId}`,
      this.getAxiosConfig()
    );
    return response.data;
  }

  // 배너 관련 API
  async getBanners() {
    const response = await axios.get(`${this.baseURL}/api/banners/`);
    return response.data;
  }

  async updateBanner(bannerId, formData) {
    const response = await axios.put(
      `${this.baseURL}/api/banners/${bannerId}`,
      formData,
      this.getAxiosConfig({ 'Content-Type': 'multipart/form-data' })
    );
    return response.data;
  }

  async createBanner(formData) {
    const response = await axios.post(
      `${this.baseURL}/api/banners/`,
      formData,
      this.getAxiosConfig({ 'Content-Type': 'multipart/form-data' })
    );
    return response.data;
  }

  async deleteBanner(bannerId) {
    const response = await axios.delete(
      `${this.baseURL}/api/banners/${bannerId}`,
      this.getAxiosConfig()
    );
    return response.data;
  }
}

// 싱글톤 인스턴스 생성
const ownerAPI = new OwnerAPI();

export default ownerAPI; 